<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">{{ cliente.id ? "Editar" : "Novo" }} cliente de API</div>
            </div>
            <div class="card-body">
              <div class="alert alert-warning p-1" v-if="token">
                <strong>Token de acesso:</strong> copie agora, ele não será exibido novamente.
                <div class="d-flex align-items-center mt-50">
                  <code class="token mr-1">{{ token }}</code>
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="copiarToken">Copiar</button>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="nome"><span class="required">*</span> Nome:</label>
                  <input id="nome" type="text" class="form-control" v-model="cliente.nome" placeholder="Ex.: ERP do cliente X" />
                </div>
                <div class="form-group col-md-6">
                  <label for="ativo">Ativo:</label>
                  <select id="ativo" class="form-control" v-model="cliente.ativo">
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="webhook_url">URL do webhook:</label>
                  <input id="webhook_url" type="text" class="form-control" v-model="cliente.webhook_url"
                    placeholder="https://sistema-cliente/webhooks/assinatura" />
                </div>
                <div class="form-group col-md-6">
                  <label for="webhook_secret">Segredo do webhook (HMAC):</label>
                  <input id="webhook_secret" type="text" class="form-control" v-model="cliente.webhook_secret"
                    :placeholder="cliente.id ? 'Em branco mantém o atual' : 'Usado para assinar o corpo do webhook'" />
                </div>
              </div>

              <span class="required_fields">
                <span class="required">*</span>
                <strong>Campos obrigatórios</strong>
              </span>
              <div class="block text-right">
                <router-link to="/clientes_api" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <button v-if="cliente.id" type="button" class="btn btn-delete ml-1" @click="regenerarToken">
                  <i class="fa fa-key"></i> Gerar novo token
                </button>
                <button type="button" class="btn btn-add ml-1" @click="salvar">
                  Salvar <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cliente: {
        nome: "",
        webhook_url: "",
        webhook_secret: "",
        ativo: true,
      },
      token: null,
    };
  },
  methods: {
    salvar() {
      const self = this;
      const api = self.$store.state.api + "clientes_api";
      const dados = { ...self.cliente };

      const requisicao = self.cliente.id
        ? axios.put(api + "/" + self.cliente.id, dados)
        : axios.post(api, dados);

      requisicao
        .then((response) => {
          self.$message("Sucesso", "Informações guardadas com sucesso", "success");
          if (!self.cliente.id) {
            // Fica na tela para o token ser copiado
            self.token = response.data.token;
            self.cliente = { ...self.cliente, ...response.data.cliente, webhook_secret: "" };
            self.$router.replace("/clientes_api/edit/" + response.data.cliente.id);
          }
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
    regenerarToken() {
      const self = this;
      if (!confirm("O token atual deixará de funcionar imediatamente. Continuar?")) {
        return;
      }

      axios
        .post(self.$store.state.api + "clientes_api/" + self.cliente.id + "/token")
        .then((response) => {
          self.token = response.data.token;
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
    copiarToken() {
      navigator.clipboard.writeText(this.token).then(() => {
        this.$message("Copiado", "Token copiado para a área de transferência.", "success");
      });
    },
    carregar(id) {
      const self = this;
      axios
        .get(self.$store.state.api + "clientes_api/" + id)
        .then((response) => {
          const cliente = response.data.data[0];
          self.cliente = { ...cliente, webhook_secret: "" };
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.carregar(this.$route.params.id);
    }
  },
};
</script>

<style scoped>
.token {
  word-break: break-all;
}
</style>
